module.exports = __webpack_public_path__ + "img/윤지영 아티스트.6f17dbc4.jpg";